import React, { useState, useEffect } from "react";
import Home from "Pages/Home/home";
import Confident from "Pages/Home/Confident";
import Infrastructure from "Pages/Home/Infrastructure";
import Platform from "Pages/Home/Platform";
import Trending from "Pages/Home/Trending";
import Installation from "Pages/Home/Installation";
import Joinus from "Pages/Home/Joinus";
import { useDispatch, useSelector } from "react-redux";
import { getSettings, getFaqs } from "store/actions";
import { useNavigate } from "react-router-dom";
import Loader from "Component/Common/Loader";
import useToastr from "helpers/toastr";


const Homepage = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, total, settingInfo, faqLoading, faqsListing } = useSelector(({ Settings }) => Settings);

  const toastr = useToastr();

   /**
     * Used for calling api of userSettings and faq section on home page
     */
  useEffect(() => {
    dispatch(getSettings());
    dispatch(getFaqs());

  }, []);

   /**
     * Used for render the UI of Home page
     */

  return (
    <>

      <Home settingInfo={settingInfo?.section1} loading={loading} />
      <Confident settingInfo={settingInfo?.section2} loading={loading} />
      <Infrastructure faqsListing={faqsListing} loading={faqLoading} />
      <Platform settingInfo={settingInfo?.section4} loading={loading} />
      <Trending settingInfo={settingInfo?.section5} loading={loading} />
      <Installation settingInfo={settingInfo?.section5} loading={loading} />
      <Joinus />

    </>
  )
}

export default Homepage